var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-container", { attrs: { fluid: "" } }, [
    _c(
      "div",
      { staticClass: "pb-3" },
      [
        _c("label", [_vm._v("Permission Type:")]),
        _vm._v(" "),
        _c("v-autocomplete", {
          staticClass: "mt-2",
          attrs: {
            items: _vm.permissionOptions,
            "item-text": "text",
            "item-value": "value",
            placeholder: "No Restrictions",
            clearable: "",
            outlined: "",
            dense: "",
            "hide-details": "",
          },
          model: {
            value: _vm.mainObject.portal_content_type_key,
            callback: function ($$v) {
              _vm.$set(_vm.mainObject, "portal_content_type_key", $$v)
            },
            expression: "mainObject.portal_content_type_key",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }